export default "__VITE_ASSET__CBcSbL48__"